import { render, staticRenderFns } from "./CardProducts.vue?vue&type=template&id=4021b703"
import script from "./CardProducts.vue?vue&type=script&lang=js"
export * from "./CardProducts.vue?vue&type=script&lang=js"
import style0 from "./CardProducts.vue?vue&type=style&index=0&id=4021b703&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports